import styles from './SignIn.scss';
import Link from 'next/link';
import { SignInForm, FormValues as SignInFormValues } from '@/components/organisms/form/SignInForm';
import { pagesPath } from '@/lib/$path';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useRouter } from 'next/dist/client/router';
import { useAuthContext } from '@/hooks/auth';
import { useSchoolContext } from '@/hooks/school';

const REDIRECT_PATH = '/';

/** organizers/SignIn */
export const SignIn: React.FC = () => {
  const router = useRouter();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<SignInFormValues>({ reValidateMode: 'onSubmit' });
  const referrer = 'string' === typeof router.query.referrer ? router.query.referrer : REDIRECT_PATH;
  const signUpQuery = { query: { referrer } };
  const authCtx = useAuthContext();
  const { school } = useSchoolContext();

  const signIn = handleSubmit(async (params: Parameters<typeof authCtx.signIn>[0]) => {
    await authCtx.signIn(params);
  });

  useEffect(() => {
    // ログイン済みであれば、目的のサイトにリダイレクトする。
    if (authCtx.isLoggedIn) {
      router.replace(referrer);
    }
  }, [authCtx.isLoggedIn]);

  return (
    <>
      {!authCtx.isLoggedIn && (
        <main className="sign-in">
          <div className="sign-in__inner">
            <h1 className="sign-in__h1">
              「{school?.name}」<br />
              ログイン
            </h1>
            <SignInForm onSubmit={signIn} register={register} errors={errors} />
            <ul className="sign-in__menu">
              <li>
                <Link href={pagesPath.sign_up.$url(signUpQuery)}>
                  <a>アカウントを作成する</a>
                </Link>
              </li>
              <li>
                <Link href={pagesPath.forgot.$url()}>
                  <a>パスワードを忘れた場合</a>
                </Link>
              </li>
              <li>
                <Link href={pagesPath.$url()}>
                  <a>トップへ戻る</a>
                </Link>
              </li>
            </ul>
          </div>
        </main>
      )}
      <style jsx>{styles}</style>
    </>
  );
};
